import React from 'react';
import { CloseIcon, WithConfirm } from '../../Components';
import { translate } from './translate';
import { deleteDraftOrder } from '../../utils/order';
export const RemoveOrderButton = (props) => (
<WithConfirm
  onClick={() => {
    const context = props.context;
    const order = props.order;

    if (order.status === 'draft') {
      deleteDraftOrder(order, context, () => {
        console.log('success');
      },
      () => {
        console.log('error');
      });
    }

    props.actions.removeOrder(props.id);
    props.onAction('remove');
    props.actions.setToast({
      title: translate('orderRemovedToast.title'),
      description: translate('orderRemovedToast.description'),
    });
  }}>
    {(onClickWithConfirm) => <CloseIcon onClick={onClickWithConfirm} />}
</WithConfirm>
);
